// extracted by mini-css-extract-plugin
module.exports = {"s18l1lqi":"s18l1lqi","sizeBadge":"sizeBadge","sizeS":"sizeS","sizeM":"sizeM","sizeL":"sizeL"};